(function () {
  'use strict';

  // The unchanged Customily scripts accept resolved bootstrap objects, not promises.
  // Start their shared configuration early; let their original requests win if late.
  var script = document.currentScript;
  if (!script || script.getAttribute('data-initialized') === 'true') return;
  var existingScript = document.getElementById('ss-customily-bootstrap');
  if (existingScript && existingScript !== script &&
      existingScript.getAttribute('data-initialized') === 'true') return;
  script.setAttribute('data-initialized', 'true');

  function diagnostic(status, reason) {
    script.setAttribute('data-state', status);
    if (reason) script.setAttribute('data-reason', reason);
  }

  var handle = script.getAttribute('data-product-handle');
  var productId = script.getAttribute('data-product-id');
  var shop = script.getAttribute('data-shop');
  if (!handle || !/^[a-z0-9][a-z0-9-]*$/i.test(handle) ||
      !/^\d+$/.test(productId || '') ||
      !/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i.test(shop || '') ||
      typeof window.fetch !== 'function' ||
      typeof window.AbortController !== 'function' ||
      typeof window.URL !== 'function' ||
      (window.customilyShopify && window.customilyShopify.scriptLoaded)) {
    diagnostic('fallback', 'ineligible');
    injectVendorNow();
    return;
  }
  function injectVendorNow() {
    if (script.getAttribute('data-customily') === 'never') return;
    ['https://cdn.customily.com/customily.js',
     'https://cdn.customily.com/shopify/static/customily.shopify.script.unified.js'].forEach(function (src) {
      var el = document.createElement('script'); el.src = src; el.defer = true; el.async = false; document.head.appendChild(el);
    });
  }

  var globalDescriptor = Object.getOwnPropertyDescriptor(window, 'customily');
  if (globalDescriptor && !('value' in globalDescriptor)) {
    diagnostic('fallback', 'preexisting');
    injectVendorNow();
    return;
  }
  var target = window.customily;
  if (target == null) {
    if ((globalDescriptor && (!('value' in globalDescriptor) || !globalDescriptor.writable)) ||
        (!globalDescriptor && !Object.isExtensible(window))) {
      diagnostic('fallback', 'preexisting');
      return;
    }
    target = {};
    window.customily = target;
  }
  if (!target || typeof target !== 'object' || Array.isArray(target) ||
      !Object.isExtensible(target) || 'shopSettings' in target || 'product' in target) {
    diagnostic('fallback', 'preexisting');
    injectVendorNow();
    return;
  }

  var state = { shopSettings: 'pending', product: 'pending' };
  diagnostic('pending');
  var controller = new window.AbortController();
  var startPath = window.location.pathname;
  var stopped = false;
  var slots = {};
  var timer;

  function owns(key) {
    var descriptor = Object.getOwnPropertyDescriptor(target, key);
    return descriptor && slots[key] && descriptor.get === slots[key].get &&
      descriptor.set === slots[key].set;
  }

  function retire(key, reason) {
    if (owns(key)) delete target[key];
    if (state[key] === 'pending') state[key] = reason;
  }

  function stop(reason) {
    if (stopped) return;
    stopped = true;
    if (reason !== 'navigation') setTimeout(function () { loadVendor('fallback'); }, 0);
    window.clearTimeout(timer);
    controller.abort();
    retire('shopSettings', reason);
    retire('product', reason);
    diagnostic('fallback', reason);
  }

  function install(key) {
    var slot = slots[key] = {};
    slot.get = function () {
      // A real consumer is ready now: never hand the vendor a pending Promise.
      retire(key, 'legacy');
      if (key === 'product') stop('legacy');
      return undefined;
    };
    slot.set = function (value) {
      // Preserve assignments from another integration, including explicit undefined.
      if (owns(key)) {
        Object.defineProperty(target, key, {
          value: value, writable: true, enumerable: true, configurable: true
        });
      }
      state[key] = 'external';
      stop('external');
    };
    Object.defineProperty(target, key, {
      get: slot.get, set: slot.set, enumerable: false, configurable: true
    });
  }

  function isObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  function validConfig(value) {
    return isObject(value) && Array.isArray(value.assignedSets);
  }

  function validResponse(value) {
    if (!isObject(value) || value.productHandle !== handle ||
        !Array.isArray(value.sets) || !validConfig(value.productConfig) ||
        !isObject(value.settings) || typeof value.settings.enabled !== 'boolean' ||
        !isObject(value.settings.upsell) || !isObject(value.settings.cartItems) ||
        !isObject(value.settings.querySelectors)) return false;
    if (value.supplierUnifiedSettings != null) {
      var supplier = value.supplierUnifiedSettings;
      if (!isObject(supplier) || !validConfig(supplier.productConfig) ||
          !Array.isArray(supplier.sets)) return false;
    }
    return true;
  }

  function sameProduct() {
    var integration = window.customilyShopify;
    return window.customily === target && window.location.pathname === startPath &&
      (!window.Shopify || !window.Shopify.shop || window.Shopify.shop === shop) &&
      !(integration && integration.productHandleIsSetMannualy &&
        integration.productHandle && integration.productHandle !== handle);
  }

  function publish(key, value) {
    if (!owns(key)) return;
    Object.defineProperty(target, key, {
      value: value, writable: true, enumerable: true, configurable: true
    });
    state[key] = 'ready';
  }

  try {
    install('shopSettings');
    install('product');
  } catch (error) {
    stop('unavailable');
    return;
  }

  timer = window.setTimeout(function () { stop('timeout'); }, 20000);
  window.addEventListener('pagehide', function () { stop('navigation'); }, { once: true });

  var url = new window.URL('https://sh.customily.com/api/settings/unified/' + encodeURIComponent(handle));
  url.searchParams.set('shop', shop);
  url.searchParams.set('productId', productId);

  Promise.resolve().then(function () {
    if (stopped) return null;
    return window.fetch(url.href, {
      method: 'GET', credentials: 'omit', signal: controller.signal,
      headers: { Accept: 'application/json' }
    });
  }).then(function (response) {
    if (stopped) return null;
    if (!response || !response.ok) throw new Error('Configuration request failed');
    return response.json();
  }).then(function (value) {
    if (stopped) return;
    if (!sameProduct()) return stop('navigation');
    if (!validResponse(value)) return stop('invalid');
    if (!owns('product')) return stop('superseded');

    // Replace only our still-unread getters. Never update settings already consumed
    // by the vendor, or values another integration assigned in the meantime.
    publish('shopSettings', value.settings);
    publish('product', value);
    stopped = true;
    window.clearTimeout(timer);
    diagnostic(state.shopSettings === 'ready' ? 'full' : 'product-only');
    loadVendor(hasPersonalization(value) ? 'sets' : null);
  }).catch(function () {
    if (!stopped) stop('error');
    // Config unavailable: fall back to loading the vendor so personalization is never lost.
    loadVendor('fallback');
  });

  // Soulyshine: the vendor bundles (~720 KB JS) are only injected when this product
  // actually has a Customily set, or when the theme asks for it via data-customily="always".
  function hasPersonalization(value) {
    var pc = value.productConfig || {};
    var sup = (value.supplierUnifiedSettings || {}).productConfig || {};
    return !!((pc.assignedSets && pc.assignedSets.length) || (value.sets && value.sets.length) ||
      (sup.assignedSets && sup.assignedSets.length));
  }
  var vendorLoaded = false;
  function loadVendor(reason) {
    if (vendorLoaded) return;
    var mode = script.getAttribute('data-customily') || 'auto';
    if (mode === 'never') { script.setAttribute('data-vendor', 'skipped'); return; }
    if (mode === 'auto' && !reason) { script.setAttribute('data-vendor', 'not-needed'); return; }
    vendorLoaded = true;
    script.setAttribute('data-vendor', reason || mode);
    ['https://cdn.customily.com/customily.js',
     'https://cdn.customily.com/shopify/static/customily.shopify.script.unified.js'].forEach(function (src) {
      var el = document.createElement('script');
      el.src = src; el.defer = true; el.async = false;
      document.head.appendChild(el);
    });
  }
  if ((script.getAttribute('data-customily') || 'auto') === 'always') loadVendor('always');
})();
